/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/intellectual-property",
  shortTitle: "Intellectual property",
  title: "Intellectual property and rights notices",
  category: "Orders and legal",
  summary: `Ownership and permitted use of the ${siteConfig.brandName} wordmark, original imagery, interface and product copy.`,
  updated: "26 October 2026",
  sections: [
    {
      heading: "Store content",
      body: [
        `The ${siteConfig.brandName} wordmark treatment, monogram, original product and editorial images, product descriptions, safety wording, page design and other original expression are protected to the extent provided by applicable law. Product names that are ordinary descriptive phrases and necessary legal or policy terminology are not claimed more broadly than the law permits.`,
      ],
    },
    {
      heading: "Personal use and restrictions",
      body: [
        `Ordinary browsing, retaining one's purchase record and sharing an unaltered link are permitted personal activities. Permission does not extend to stripping attribution, licensing the visual assets, building a competing commercial catalog from the photographs, transplanting substantial descriptions, suggesting endorsement, or presenting ${siteConfig.brandName} branding in a deceptive listing. A separate lawful basis may of course permit an otherwise restricted use.`,
      ],
    },
    {
      heading: "Third-party rights",
      body: [
        "Payment-service marks, browser technology and open-source packages remain subject to their owners' terms. The storefront does not claim ownership of them. Product images were generated specifically for this implementation and avoid third-party logos and copied marketplace photography.",
      ],
    },
    {
      heading: "Rights concerns",
      body: [
        `A rights holder should email a precise URL, identify the protected work or mark, explain the claimed basis, provide contact details and state the requested action. ${siteConfig.brandName} will review, may request verification, and will correct, restrict or remove material where appropriate. Knowingly false notices may harm others; good-faith counter-information will also be considered. This process does not replace any mandatory legal remedy.`,
      ],
    },
  ],
};
